import { gql } from '@apollo/client'
import { DeleteBillingInputMutation } from './types'

export interface PaymentLinkMutationVariables extends Readonly<{ input: { towingRecordId: number } }> {}

export type PaymentLinkInput = PaymentLinkMutationVariables['input']

export interface DeleteBillingMutationVariables
  extends Readonly<{
    input: DeleteBillingInputMutation
  }> {}

export const DELETE_BILLING = gql`
  mutation DeleteBilling($input: DeleteBillingInput!) {
    deleteBilling(input: $input) {
      __typename
      ... on UnauthorizedError {
        error {
          code
          message
        }
      }
      ... on GenericError {
        genericError: error {
          code
          message
        }
      }
      ... on DeleteBillingSuccess {
        success
      }
    }
  }
`

export const SEND_PAYMENT_LINK = gql`
  mutation SendPaymentLink($input: PaymentLinkInput!) {
    sendPaymentLink(input: $input) {
      __typename
      ... on SendPaymentLinkSuccess {
        success
      }
      ... on UnauthorizedError {
        error {
          code
          message
        }
      }
      ... on ResourceNotFoundError {
        error {
          code
          message
        }
      }
      ... on InvalidStateError {
        error {
          code
          message
        }
      }
    }
  }
`

export const RESEND_PAYMENT_LINK = gql`
  mutation ResendPaymentLink($input: PaymentLinkInput!) {
    resendPaymentLink(input: $input) {
      __typename
      ... on ResendPaymentLinkSuccess {
        success
      }
      ... on UnauthorizedError {
        error {
          code
          message
        }
      }
      ... on ResourceNotFoundError {
        error {
          code
          message
        }
      }
      ... on InvalidStateError {
        error {
          code
          message
        }
      }
    }
  }
`

export const CANCEL_PAYMENT_LINK = gql`
  mutation CancelPaymentLink($input: PaymentLinkInput!) {
    cancelPaymentLink(input: $input) {
      __typename
      ... on CancelPaymentLinkSuccess {
        success
      }
      ... on UnauthorizedError {
        error {
          code
          message
        }
      }
      ... on ResourceNotFoundError {
        error {
          code
          message
        }
      }
      ... on InvalidStateError {
        error {
          code
          message
        }
      }
    }
  }
`
